import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductSearchService } from '../_services/product-search.service';
import { CategorySearchDetails } from '../_models/category-search-details';
import { CategorySearchService } from '../_services/category-search.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-product-search',
  templateUrl: './product-search.component.html',
  styleUrls: ['./product-search.component.css']
})
export class ProductSearchComponent implements OnInit {
  categoryId: any;
  searchKeyword: String;
  updateFlag: string;
  categorySearchDetails: CategorySearchDetails;
  filtersList: any[] = [];
  productCategoryName: Array<String> = [];
  imageURL: string;
  parentCategoryName: any;
  productCount: any;
  isSelected: Boolean = true;
  finalProduct = [];
  products = [];
  attributeValue = [];
  attributeName = [];
  productIdList = []
  filterList = []
  productAttribute = [];
  attributeValues = [];
  categoryAttributeValues = [];
  value = [];
  userId: Number;
  categories = []
  sortCategoryId: Number;
  selected = 'Latest'
  constructor(

    private activatedRoute: ActivatedRoute,
    private productSearchService: ProductSearchService,
    private router: Router,
    private categoryService: CategorySearchService,
    private cookie: CookieService


  ) {

    this.activatedRoute.params.subscribe(params => {
      this.categoryId = params['id'];
      this.searchKeyword = params['searchKeyword']
      this.updateFlag = 'true';

    });
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

  }

  ngOnInit() {
    this.getProductBySearchKeyword(this.categoryId, this.searchKeyword)
  }



  getProductBySearchKeyword(categoryId, searchKeyword) {
    this.userId = +(this.cookie.check("UserId") ? this.cookie.get("UserId") : null);
    this.productSearchService.getProductBySearchKeyword(categoryId, searchKeyword,this.userId).subscribe(resp => {
      this.categorySearchDetails = resp as CategorySearchDetails;
      this.imageURL = this.categorySearchDetails.productCategory['imageURL'];
      this.imageURL = this.removeSpaces(this.imageURL)
      this.parentCategoryName = this.categorySearchDetails.productCategory['parentCategoryName'];
      this.productCategoryName = this.categorySearchDetails.productCategory['name'];
      this.productCount = this.categorySearchDetails.productCategory['totalProducts'];
      this.filtersList = this.categorySearchDetails.categoryFilters;
      this.categories = this.categorySearchDetails.categories;
      this.products = this.categorySearchDetails.products;
      this.filtersList.filter(filters => {
        this.categoryAttributeValues = filters.categoryAttributeValues

        this.categoryAttributeValues.forEach(resp => {
          resp['isIncluded'] = true

        })
        this.filterList.push({
          categoryAttributeName: filters.categoryAttributeName, categoryAttributeValues: this.categoryAttributeValues, categoryAttributeId: filters.categoryAttributeId
        })
      })

      this.products.filter(products => {
        let i = this.finalProduct.findIndex(x => x.value == products.productId);
        if (i <= -1) {
          console.log(products.mainImage,"MY product Image");
            this.finalProduct.push({
              productId: products.productId, mainImage: products.mainImage, hoverImage: products.hoverImage, availableColors: products.availableColors,
              price: products.price, productName: products.productName, isSelected: true, availableSize: products.availableSize, productCategoryAttribute: products.productCategoryAttribute
            })
        }
      })
    })
  }

  removeSpaces(url) {
    return encodeURIComponent(decodeURIComponent(url).replace(/\s+/g, ''));
    }
    
    

  filter(event, value) {
    if (!event.checked) {
      this.finalProduct.filter(filterProducts => {
        filterProducts.productCategoryAttribute.filter((categoryAttribute, i) => {
          this.filterList.filter(finalFilters => {
            finalFilters.categoryAttributeValues.filter(filter => {
              if (value.isIncluded == true && value.attributeValue == filter.attributeValue) {
                filter.isIncluded = false
              }
              if (filter.isIncluded == false && value.attributeValue == categoryAttribute.categoryAttributeValue) {
                filterProducts.isSelected = false
              }
            }
            )
          })
        })
      })
    }
    else {
      this.finalProduct.filter(filterProducts => {
        filterProducts.productCategoryAttribute.filter((categoryAttribute, i) => {
          this.filterList.filter(finalFilters => {
            finalFilters.categoryAttributeValues.filter(filter => {
              if (value.isIncluded == false && value.attributeValue == filter.attributeValue) {
                filter.isIncluded = true
              }
              if (filter.isIncluded == true && value.attributeValue == categoryAttribute.categoryAttributeValue) {
                filterProducts.isSelected = true
              }
            })
          })
        })
      })

    }

  }

  productByCategory(event, id) {
    this.finalProduct = []
    this.filterList = []
    this.categories = []
    this.sortCategoryId = id
    this.getProductBySearchKeyword(id, this.searchKeyword)

  }

  getSortedProducts(event) {
    if (this.categoryId== '') {
      this.categories.filter(resp => {
        this.products.filter(newResp => {
          if (resp.categoryId == newResp.categoryId) {
            this.sortCategoryId = resp.categoryId
          }
        })
      })
    } else {
      this.sortCategoryId = this.categoryId
    }



    this.finalProduct = []
    this.filterList = []
    this.categoryService.getCategoryDetailsById(this.sortCategoryId, this.userId, event,this.searchKeyword).subscribe(resp => {

      this.categorySearchDetails = resp as CategorySearchDetails;
      console.log(this.categorySearchDetails)
      this.imageURL = this.categorySearchDetails.productCategory['imageURL']
      this.parentCategoryName = this.categorySearchDetails.productCategory['parentCategoryName']
      this.productCount = this.categorySearchDetails.productCategory['totalProducts']
      this.filtersList = this.categorySearchDetails.categoryFilters;
      this.products = this.categorySearchDetails.products
      this.filtersList.filter(filters => {
        this.categoryAttributeValues = filters.categoryAttributeValues

        this.categoryAttributeValues.forEach(resp => {
          resp['isIncluded'] = true

        })
        this.filterList.push({
          categoryAttributeName: filters.categoryAttributeName, categoryAttributeValues: this.categoryAttributeValues, categoryAttributeId: filters.categoryAttributeId
        })
      })

      this.products.filter(products => {
        let i = this.finalProduct.findIndex(x => x.value == products.productId);
        if (i <= -1) {
          this.finalProduct.push({
            productId: products.productId, mainImage: products.mainImage, hoverImage: products.hoverImage, availableColors: products.availableColors,
            price: products.price, productName: products.productName, isSelected: true, availableSize: products.availableSize, productCategoryAttribute: products.productCategoryAttribute
          })
        }
      })
    })


  }

  /*---Sorting Dropdown List--- */
  sortingList: Sort[] = [
    { value: '0', viewValue: 'Latest' },
    { value: '1', viewValue: 'Featured products' },
    { value: '2', viewValue: 'Price (Low to High)' },
    { value: '3', viewValue: 'Price (High to Low)' },
  ];
}

/*---Interface for sorter values----*/
export interface Sort {
  value: string;
  viewValue: string;
}
